import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './styles.css';

export interface NavItem {
  /**
   * Label to display for the navigation item
   */
  label: string;
  
  /**
   * Path to navigate to
   */
  path: string;
  
  /**
   * Optional icon component
   */
  icon?: React.ReactNode;
  
  /**
   * Optional badge content
   */
  badge?: string | number;
}

export interface MainNavProps {
  /**
   * Array of navigation items
   */
  items: NavItem[];
  
  /**
   * Whether the navigation is collapsed
   * @default false
   */
  collapsed?: boolean;
  
  /**
   * Additional CSS class names
   */
  className?: string;
}

export const MainNav: React.FC<MainNavProps> = ({
  items,
  collapsed = false,
  className = ''
}) => {
  const location = useLocation();
  
  return (
    <nav className={`main-nav ${collapsed ? 'collapsed' : ''} ${className}`.trim()}>
      <ul className="nav-list">
        {items.map((item) => {
          const isActive = location.pathname === item.path || 
                         (item.path !== '/' && location.pathname.startsWith(item.path));
          
          return (
            <li key={item.path} className="nav-item">
              <NavLink
                to={item.path}
                className={`nav-link ${isActive ? 'active' : ''}`}
                title={collapsed ? item.label : undefined}
              >
                {item.icon && (
                  <span className="nav-icon" aria-hidden="true">
                    {item.icon}
                  </span>
                )}
                
                {!collapsed && (
                  <span className="nav-label">{item.label}</span>
                )}
                
                {!collapsed && item.badge && (
                  <span className="nav-badge">{item.badge}</span>
                )}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MainNav; 